import { ILocation, OverlayAttributeType } from "../../../constants/product-customizations/customization";
import {
    TPrintedImageCustomizationSelection,
    TPrintedTextCustomizationSelection,
} from "constants/product-customizations/customization-selection.types";
import React from "react";
import { Image2dOverlay } from "./image-2d-overlay";
import { Text2dOverlay } from "./text-2d-overlay";
import classNames from "classnames";
import makeStyles from "@material-ui/styles/makeStyles";

type IOverlay2dPropsSelection<Type, Selection> = {
    type: Type;
    selection: Selection;
    defaults?: Selection;
};

type IOverlay2dImageProps = IOverlay2dPropsSelection<OverlayAttributeType.IMAGE, TPrintedImageCustomizationSelection>;
type IOverlay2dTextProps = IOverlay2dPropsSelection<OverlayAttributeType.TEXT, TPrintedTextCustomizationSelection>;

export type IOverlay2dProps = (IOverlay2dImageProps | IOverlay2dTextProps) & {
    location?: ILocation;
    rotation?: number;
};

const useStyles = makeStyles({
    overlay: {
        position: "absolute",
        border: "1px solid grey",
        borderStyle: "dotted",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
    },
});

export const Overlay2d: React.FC<IOverlay2dProps> = ({ type, location, selection, rotation }) => {
    const classes = useStyles();
    if (!location || ![OverlayAttributeType.IMAGE, OverlayAttributeType.TEXT].includes(type)) {
        return null;
    }

    const { x = "0", y = "0", width = "0", height = "0" } = location;
    const overlayStyle = {
        top: `${y}%`,
        left: `${x}%`,
        width: `${width}%`,
        height: `${height}%`,
    };

    const render = (element: React.ReactNode) => (
        <div className={classNames(classes.overlay, "overlay-container")} style={overlayStyle}>
            {element}
        </div>
    );

    switch (type) {
        case OverlayAttributeType.IMAGE:
            return render(<Image2dOverlay imageSource={selection?.displayValue} rotation={rotation} />);
        case OverlayAttributeType.TEXT:
            return render(<Text2dOverlay selection={selection} rotation={rotation} />);
        default:
            return null;
    }
};
